import { Form } from 'factorial-form'
import { makeObservable, observable } from 'mobx'

import AccessGroupForm from '../store/models/AccessGroupForm'
import { REVIEWER_TYPES } from './reviewerTypes'

class RespondentsFactorialForm extends Form {
  manualMembers: number[] = []

  constructor(values: {}, types: {}) {
    super(values, types)
    makeObservable(this, {
      manualMembers: observable,
    })
  }

  data(): Record<string, any> {
    return {
      manualMembers: this.manualMembers,
      ...super.data(),
    }
  }
}

export default class ReviewRespondentsForm extends AccessGroupForm {
  respondentsForm = new RespondentsFactorialForm(
    {
      self: true,
      manager: true,
      reportees: true,
      peers: true,
      manual: false,
    },
    {
      self: 'boolean',
      manager: 'boolean',
      reportees: 'boolean',
      peers: 'boolean',
      manual: 'boolean',
    }
  )

  valid(): boolean {
    const manual = this.respondentsForm.get('manual').value

    if (manual && this.respondentsForm.manualMembers.length === 0) {
      return false
    }

    if (
      !Object.values(REVIEWER_TYPES).some((reviewer) => this.respondentsForm.get(reviewer).value)
    ) {
      return false
    }

    return super.valid()
  }

  data(): Record<string, any> {
    return { ...this.respondentsForm.data(), ...super.data() }
  }
}
